function modulo(n, m) {
    return ((n % m) + m) % m;
};

export default modulo;
export { modulo };